<script>
export default {
  name: "inputSelect",
  props: {
    label: {
      type: String,
      require: true,
    },
    values: {
      type: [Array, Object],
      require: true,
    },
    modelValue: String,
  },
};
</script>

<template functional>
  <label class="text-sm font-medium text-green-darker">
    <slot name="label">{{ props.label }}</slot>

    <select
      :ref="data.ref"
      class="custom-arrow bg-no-repeat a-select-input"
      :class="[data.class, data.staticClass]"
      :style="[data.style, data.staticStyle]"
      v-bind="data.attrs"
      v-on="{ ...listeners, input: e => listeners.input(e.target.value) }"
    >
      <option disabled :selected="props.modelValue === ''" value="">
        <slot name="disabled-option">-</slot>
      </option>
      <option
        v-for="option in props.values"
        :value="option.value || option"
        :key="option.value || option"
        :selected="
          props.modelValue !== '' &&
            (props.modelValue === option.value || props.modelValue === option)
        "
      >
        <!-- {{ props.value }} -->
        <slot :option="option">{{ option.text }}</slot>
      </option>
    </select>
  </label>
</template>

<style lang="scss" scoped>
.custom-arrow {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 10L12 15L17 10H7Z' fill='%23B4AEBA'/%3E%3C/svg%3E%0A");
  background-origin: border-box;
  background-position: top 50% right 0.5rem;
}

select.a-select-input:disabled {
  @apply border-light-200;
  @apply bg-light-200;
  &::placeholder {
    @apply text-dark-0;
  }
}
select.a-select-input {
  @apply transition-all;
  @apply duration-100;
}
</style>
